// ── Hero image entrance animation ────────────────────────────
const heroImg = document.getElementById('heroImage');
if (heroImg) {
  const onLoad = () => heroImg.classList.add('loaded');
  heroImg.complete ? onLoad() : heroImg.addEventListener('load', onLoad);
}

// ── Hero auto-advancing slider ────────────────────────────────
(function() {
  const wrap  = document.getElementById('heroSlidesWrap');
  const dots  = document.querySelectorAll('.hero-dot');
  if (!wrap || dots.length < 2) return;

  let current = 0;
  const total = dots.length;
  const INTERVAL = 6000;

  function goTo(idx) {
    wrap.classList.toggle('slide-1', idx === 1);
    dots.forEach((d, i) => d.classList.toggle('hero-dot--active', i === idx));
    current = idx;
  }

  // Dot click
  dots.forEach(d => d.addEventListener('click', () => goTo(+d.dataset.slide)));

  // Auto-advance
  let timer = setInterval(() => goTo((current + 1) % total), INTERVAL);

  // Pause on hover
  wrap.addEventListener('mouseenter', () => clearInterval(timer));
  wrap.addEventListener('mouseleave', () => {
    timer = setInterval(() => goTo((current + 1) % total), INTERVAL);
  });
})();

// ── Scroll reveal ────────────────────────────────────────────
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

// ── Sticky mobile CTA bar ────────────────────────────────────
(function() {
  var ctaBar = document.getElementById('mobileCta');
  var hero = document.querySelector('.hero');
  if (!ctaBar || !hero) return;
  var ctaObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        ctaBar.classList.remove('visible');
      } else {
        ctaBar.classList.add('visible');
      }
    });
  }, { threshold: 0 });
  ctaObserver.observe(hero);
})();

// ── Quick Add — real AJAX add-to-cart ─────────────────────────
function addedFeedback(btn) {
  var card = btn.closest('.product-card');
  if (!card) return;
  var href = card.getAttribute('href');
  var match = href && href.match(/variant=(\d+)/);
  if (!match) { window.location.href = href; return; }

  btn.textContent = 'Adding\u2026';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(match[1]), quantity: 1 }] })
  })
  .then(function(res) {
    if (!res.ok) throw new Error(res.status);
    return res.json();
  })
  .then(function() {
    btn.textContent = 'Added \u2713';
    btn.style.background = '#3d6b4f';
    btn.style.color = '#fff';
    // Refresh cart bubble count
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var bubbles = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
      bubbles.forEach(function(el){ el.textContent = cart.item_count; });
      var bubble = document.querySelector('.cart-count-bubble');
      if (bubble && cart.item_count > 0) bubble.removeAttribute('hidden');
    });
    setTimeout(function() {
      btn.textContent = 'Quick Add';
      btn.style.background = '';
      btn.style.color = '';
      btn.disabled = false;
    }, 2200);
  })
  .catch(function() {
    btn.textContent = 'View Product';
    setTimeout(function() {
      btn.textContent = 'Quick Add';
      btn.disabled = false;
    }, 1600);
  });
}



// ── Horizontal rails: arrow controls + end-of-scroll fade ────────────────
(function () {
  const rails = [
    { wrap: '.collections-scroll-wrap', rail: '.collections-scroller', btns: '.collections-nav__btn:not([data-rail])', gap: 14 },
    { wrap: '.spring-drop__rail-wrap',  rail: '.spring-drop__grid',    btns: '.collections-nav__btn[data-rail="rings"]', gap: 22 },
  ];

  rails.forEach(cfg => {
    const wrap = document.querySelector(cfg.wrap);
    const rail = document.querySelector(cfg.rail);
    if (!wrap || !rail) return;
    const btns = document.querySelectorAll(cfg.btns);
    const card = rail.querySelector('.product-card, .collection-card');

    // Scroll whole columns so the rail never stops mid-card.
    const step = () => {
      const w = (card ? card.getBoundingClientRect().width : 240) + cfg.gap;
      return Math.max(w, Math.floor(rail.clientWidth / w) * w);
    };

    function sync() {
      const max = rail.scrollWidth - rail.clientWidth;
      const x = rail.scrollLeft;
      wrap.classList.toggle('is-end', x >= max - 4);
      btns.forEach(b => {
        b.disabled = b.dataset.scroll === 'prev' ? x <= 2 : x >= max - 4;
      });
    }

    btns.forEach(b => b.addEventListener('click', () => {
      rail.scrollBy({ left: b.dataset.scroll === 'prev' ? -step() : step(), behavior: 'smooth' });
    }));
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
